import { useEffect } from 'react';

export const ShowDev = () => {
  useEffect(() => {
    localStorage.setItem('devOverlay', 'true');
    // navigate to root
    window.location.href = '/';
  }, []);
  return null;
};
